import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { Helmet } from 'react-helmet-async';

import GirderForm from './editor-component/GirderForm';
import GalleryForm from './editor-component/GalleryForm';
import TrestleForm from './editor-component/TrestleForm';
import StringerForm from './editor-component/StringerForm';
import WalkwayForm from './editor-component/WalkwayForm';
// import HoodCoverForm from './editor-component/HoodCoverForm';
import SideCoverForm from './editor-component/SideCoverForm';
import DeckingPlateForm from './editor-component/DeckingPlateForm';
import SkirtboardForm from './editor-component/SkirtboardForm';
import PulleyFrameForm from './editor-component/PulleyFrameForm';
import CommonBedForm from './editor-component/CommonBedForm';
import TakeupForm from './editor-component/TakeupForm';
import ChuteForm from './editor-component/ChuteForm';
import ChuteLinerForm from './editor-component/ChuteLinerForm';
import ChuteDamperForm from './editor-component/ChuteDamperForm';
import ShuttleForm from './editor-component/ShuttleForm';
import TripperForm from './editor-component/TripperForm';
import OverbridgeForm from './editor-component/OverbridgeForm';
import InternalBeltCleanerForm from './editor-component/InternalBeltCleaner';
import SafetyCover from './editor-component/SafeyCover';
import WheelAssyForm from './editor-component/WheelAssyForm';
import RailForm from './editor-component/RailForm';
import AnchorBoltForm from './editor-component/AnchorBoltForm';
import PCGirderForm from './editor-component/PCGirderForm';
import PCPanelForm from './editor-component/PCPanelForm';


const StructureEstimateForm = ({ onSaveStructure, onChangeWeightSummary, project, title, body, conveyorType }) => {
    const { input, drives, structure, pulley } = body;

    if (!title || !body) {
        return <StructureEstimateFormBlock>Structure Not Found!!!</StructureEstimateFormBlock>;
    }

    // 아래에 있는 것이 무엇인지 점검할 것.
    const { selectedMotor } = drives[0];
    const { length: horizontalLength, height: verticalLift, carrySpacing, beltWidth, carcassType } = input;

    return (
        <StructureEstimateFormBlock>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <StructureHead>
                <ProjectInfo>
                    <span>{project?.title}</span>
                </ProjectInfo>
                <ConveyorInfo>
                    <span onClick={/*onBackToList*/ null}>
                        <b>{title}</b>
                    </span>
                </ConveyorInfo>
                <SubInfo>
                    <span>{`BW${beltWidth}mm / ${horizontalLength}mL / ${verticalLift}mH`}</span>
                </SubInfo>
                {/* <ProfileInfo>
                    <img src={profileImage} alt="프로파일 이미지" />
                </ProfileInfo> */}
            </StructureHead>
            <StructureBody>
                <Item>
                    {conveyorType === 'Troughed' && <GirderForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        girders={structure?.girder}
                        beltWidth={beltWidth}
                    />}
                    {conveyorType === 'Pipe' && <PCGirderForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        girders={structure?.girder}
                        beltWidth={beltWidth}
                    />}
                </Item>
                {conveyorType === 'Pipe' && (
                    <Item>
                        <PCPanelForm
                            onSaveStructure={onSaveStructure}
                            onChangeWeightSummary={onChangeWeightSummary}
                            pcPanels={structure?.pcPanel}
                            beltWidth={beltWidth}
                            horizontalLength={horizontalLength}
                            verticalLift={verticalLift}
                            carrySpacing={carrySpacing}
                        />
                    </Item>
                )}
                <Item>
                    <GalleryForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        galleries={structure?.gallery}
                    />
                </Item>
                <Item>
                    <TrestleForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        trestles={structure?.trestle}
                        beltWidth={beltWidth}
                    />
                </Item>
                <Item>
                    <StringerForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        stringers={structure?.stringer}
                        beltWidth={beltWidth}
                    />
                </Item>
                <Item>
                    <WalkwayForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        walkways={structure?.walkway}
                        beltWidth={beltWidth}
                    />
                </Item>
                {/* <Item>
                    <HoodCoverForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        hoodCovers={structure?.hoodCover}
                    />
                </Item> */}
                <Item>
                    <SideCoverForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        sideCovers={structure?.sideCover}
                    />
                </Item>
                <Item>
                    <DeckingPlateForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        deckingPlates={structure?.deckingPlate}
                        beltWidth={beltWidth}
                    />
                </Item>
                <Item>
                    <SkirtboardForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        skirtboards={structure?.skirtboard}
                        beltWidth={beltWidth}
                    />
                </Item>
                <Item>
                    <PulleyFrameForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        pulleyFrames={structure?.pulleyFrame}
                        pulleys={pulley}
                        drives={drives}
                        beltWidth={beltWidth}
                    />
                </Item>
                <Item>
                    <CommonBedForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        commonBeds={structure?.commonBed}
                        selectedMotor={selectedMotor}
                    />
                </Item>
                <Item>
                    <ChuteForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        chutes={structure?.chute}
                        beltWidth={beltWidth}
                    />
                </Item>
                <Item>
                    <ChuteDamperForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        chuteDampers={structure?.chuteDamper}
                        beltWidth={beltWidth}
                    />
                </Item>
                <Item>
                    <ChuteLinerForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        chuteLiners={structure?.chuteLiner}
                        beltWidth={beltWidth}
                    />
                </Item>
                <Item>
                    <TakeupForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        takeups={structure?.takeup}
                        horizontalLength={horizontalLength}
                        beltWidth={beltWidth}
                        carcassType={carcassType}
                        drives={drives}
                    />
                </Item>
                <Item>
                    <TripperForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        trippers={structure?.tripper}
                        beltWidth={beltWidth}
                    />
                </Item>
                <Item>
                    <ShuttleForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        shuttles={structure?.shuttle}
                        beltWidth={beltWidth}
                    />
                </Item>
                <Item>
                    <WheelAssyForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        wheelAssys={structure?.wheelAssy}
                        beltWidth={beltWidth}
                    />
                </Item>
                <Item>
                    <RailForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        rails={structure?.rail}
                    />
                </Item>
                <Item>
                    <OverbridgeForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        overbridges={structure?.overbridge}
                        beltWidth={beltWidth}
                        horizontalLength={horizontalLength}
                    />
                </Item>
                <Item>
                    <InternalBeltCleanerForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        internalBeltCleaners={structure?.internalBeltCleaner}
                        beltWidth={beltWidth}
                    />
                </Item>
                <Item>
                    <SafetyCover
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        safetyCovers={structure?.safetyCover}
                    />
                </Item>
                <Item>
                    <AnchorBoltForm
                        onSaveStructure={onSaveStructure}
                        onChangeWeightSummary={onChangeWeightSummary}
                        anchorBolts={structure?.anchorBolt}
                        stringerWeight={structure?.summary?.stringer?.totalWeight}
                        trestleWeight={structure?.summary?.trestle?.totalWeight}
                    />
                </Item>
            </StructureBody>
        </StructureEstimateFormBlock>
    );
};

export default StructureEstimateForm;

/* =================   Styles   ================== */
const StructureEstimateFormBlock = styled.div`
    margin-top: 2rem;
    margin-bottom: 2rem;
    padding: 0 1rem;

    .id-column {
        // background-color: red;
        width: 100px;
    }
    
    .total-weight {
        // background-color: red;
        width: 100px;
    }
    .btn-add {
        // background-color: blue;
        width: 50px;
    }
`;

const StructureHead = styled.div`
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    // border-bottom: 1px solid ${palette.gray[2]};
    // padding-bottom: 2rem;
    // margin-bottom: 3rem;
    h3 {
        font-size: 1.25rem;
        // 기본 높이가 높기때문에 위아래 마진을 줄이기 위해
        line-height: 1.5;
        margin: 0;
    }
`;

const StructureBody = styled.div`
    // display: flex;
    // flex-wrap: wrap;
    margin-top: 3rem;
`;

const ProjectInfo = styled.div`
    color: ${palette.cyan[6]};
    &:hover {
        color: ${palette.cyan[4]};
        cursor: pointer;
    }
`;

const ConveyorInfo = styled.div`
    color: ${palette.cyan[6]};
    &:hover {
        color: ${palette.cyan[4]};
        cursor: pointer;
    }
`;

const SubInfo = styled.div`
    color: ${palette.gray[6]};
`;

const Item = styled.div`
    // min-width: 450px;
    // min-height:100px;
    // margin: 1rem 1rem;
    // padding: 2rem;
    // background-image: linear-gradient(to bottom right, ${palette.gray[0]}, ${palette.cyan[0]});
    // box-shadow: 5px 5px 10px ${palette.gray[3]};
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;

    & + & {
        margin-top: 2rem;
    }
`;
